var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5201 11.46C21.5201 16.08 17.78 19.82 13.16 19.82C12.75 19.82 12.35 19.79 11.96 19.72C12.12 19.45 12.19 19.13 12.19 18.8C12.19 17.64 11.26 16.71 10.1 16.71C9.85005 16.71 9.59005 16.77 9.35005 16.85C9.36005 16.75 9.39005 16.65 9.39005 16.55C9.39005 15.14 8.23005 13.99 6.82005 13.99C6.28005 13.99 5.77005 14.16 5.37005 14.46C5.00005 13.53 4.80005 12.51 4.80005 11.45C4.80005 6.83 8.54005 3.09 13.16 3.09C13.65 3.09 14.13 3.13 14.61 3.22C12.07 3.79 10.15 6.06 10.15 8.77C10.15 11.91 12.71 14.46 15.84 14.46C18.55 14.46 20.83 12.54 21.39 10C21.47 10.48 21.5201 10.96 21.5201 11.45V11.46Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.18 18.81C12.18 19.13 12.11 19.46 11.95 19.73C11.65 20.35 11.06 20.79 10.35 20.87V20.9H4.29996C3.27996 20.9 2.45996 20.08 2.45996 19.06C2.45996 18.04 3.27996 17.24 4.29996 17.24H4.33996C4.27996 17.03 4.23996 16.8 4.23996 16.56C4.23996 15.68 4.67996 14.92 5.33996 14.47C5.74996 14.17 6.25996 14 6.78996 14C8.19996 14 9.35996 15.14 9.35996 16.56C9.35996 16.66 9.32996 16.76 9.31996 16.86C9.55996 16.78 9.80996 16.72 10.07 16.72C11.23 16.72 12.16 17.65 12.16 18.81H12.18Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 9.92H14.54L16.43 7.05H14.54",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.13 7.79H18.24L20.13 4.93H18.24",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepIcon);
export default __webpack_public_path__ + "static/media/sleep_icon.c07bffee8dc5ab3778e05f4a88116a36.svg";
export { ForwardRef as ReactComponent };